var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"header_css",attrs:{"md":"12"}},[_c('div',{staticClass:"header__calendar"},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('p',{staticClass:"bold c-white header__calendar-day"},[_vm._v("\n          Ngày "+_vm._s(_vm.date.getDate())+"\n        ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }